(() => {
  const HEADER_SELECTOR = '[data-twomatoes-header]';
  const TOGGLE_SELECTOR = '[data-twomatoes-menu-toggle]';
  const MENU_SELECTOR = '[data-twomatoes-mobile-menu]';
  const LOCALIZATION_SELECTOR = '[data-twomatoes-localization]';
  const DESKTOP_LOCALIZATION_SELECTOR = '[data-twomatoes-localization-desktop]';
  const MOBILE_LOCALIZATION_SELECTOR = '[data-twomatoes-localization-mobile]';
  const RESPONSIVE_QUERY = window.matchMedia('(max-width: 991px)');
  const REDUCED_MOTION_QUERY = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initializedHeaders = new WeakSet();

  const setMenuState = (header, open, animate = true) => {
    const toggle = header.querySelector(TOGGLE_SELECTOR);
    const menu = header.querySelector(MENU_SELECTOR);
    const lineOne = toggle?.querySelector('.navbar_hamburger-line._1');
    const lineTwo = toggle?.querySelector('.navbar_hamburger-line._2');

    if (!toggle || !menu) return;

    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    header.dataset.twomatoesMenuOpen = String(open);

    const finishClosedState = () => {
      if (!open) menu.hidden = true;
    };

    if (open) menu.hidden = false;

    if (typeof window.gsap !== 'undefined' && animate && !REDUCED_MOTION_QUERY.matches) {
      window.gsap.killTweensOf([menu, lineOne, lineTwo]);

      if (open) {
        window.gsap.fromTo(menu, { opacity: 0, y: -8 }, { opacity: 1, y: 0, duration: 0.25, ease: 'power1.out', overwrite: 'auto' });
      } else {
        window.gsap.to(menu, { opacity: 0, y: -8, duration: 0.2, ease: 'power1.in', overwrite: 'auto', onComplete: finishClosedState });
      }

      if (lineOne) window.gsap.to(lineOne, { y: open ? 4 : 0, rotation: open ? 45 : 0, duration: 0.25, ease: 'power1.out', overwrite: 'auto' });
      if (lineTwo) window.gsap.to(lineTwo, { y: open ? -4 : 0, rotation: open ? -45 : 0, duration: 0.25, ease: 'power1.out', overwrite: 'auto' });
      return;
    }

    menu.style.opacity = open ? '1' : '0';
    menu.style.transform = open ? 'translateY(0)' : 'translateY(-8px)';
    if (lineOne) lineOne.style.transform = open ? 'translateY(4px) rotate(45deg)' : '';
    if (lineTwo) lineTwo.style.transform = open ? 'translateY(-4px) rotate(-45deg)' : '';
    finishClosedState();
  };

  const closeLocalizationPanel = (localization) => {
    const button = localization?.querySelector('[aria-expanded]');
    const panel = localization?.querySelector('.localization-wrapper');

    if (button) button.setAttribute('aria-expanded', 'false');
    if (panel) panel.hidden = true;
  };

  const moveLocalization = (header) => {
    const localization = header.querySelector(LOCALIZATION_SELECTOR);
    const desktopSlot = header.querySelector(DESKTOP_LOCALIZATION_SELECTOR);
    const mobileSlot = header.querySelector(MOBILE_LOCALIZATION_SELECTOR);
    const target = RESPONSIVE_QUERY.matches ? mobileSlot : desktopSlot;

    if (!localization || !target || localization.parentElement === target) return;

    closeLocalizationPanel(localization);
    target.appendChild(localization);
  };

  const resetHeaderState = () => {
    document.querySelectorAll(HEADER_SELECTOR).forEach((header) => {
      setMenuState(header, false, false);
      moveLocalization(header);
    });
  };

  const handleBreakpointChange = () => {
    document.querySelectorAll(HEADER_SELECTOR).forEach((header) => setMenuState(header, false, false));

    requestAnimationFrame(() => {
      requestAnimationFrame(resetHeaderState);
    });
  };

  const initializeHeader = (header) => {
    if (initializedHeaders.has(header)) return;

    const toggle = header.querySelector(TOGGLE_SELECTOR);
    const menu = header.querySelector(MENU_SELECTOR);

    initializedHeaders.add(header);
    moveLocalization(header);
    setMenuState(header, false, false);

    toggle?.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      setMenuState(header, open, true);
    });

    menu?.addEventListener('click', (event) => {
      if (event.target.closest('a')) setMenuState(header, false, true);
    });
  };

  const initialize = () => {
    document.querySelectorAll(HEADER_SELECTOR).forEach(initializeHeader);
    resetHeaderState();

    RESPONSIVE_QUERY.addEventListener('change', handleBreakpointChange);

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll(HEADER_SELECTOR).forEach((header) => setMenuState(header, false, true));
    });

    document.addEventListener('click', (event) => {
      document.querySelectorAll(HEADER_SELECTOR).forEach((header) => {
        if (header.dataset.twomatoesMenuOpen !== 'true' || header.contains(event.target)) return;
        setMenuState(header, false, true);
      });
    });

    if (window.Shopify?.designMode) {
      document.addEventListener('shopify:section:load', (event) => {
        const header = event.target.querySelector?.(HEADER_SELECTOR) || (event.target.matches?.(HEADER_SELECTOR) ? event.target : null);
        if (header) initializeHeader(header);
        handleBreakpointChange();
      });
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
